import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const TRACKS = [
  {
    code: "01",
    label: "Invest",
    title: "Capital Partners",
    body: "Equity into the LRG Leather Botswana SPV. $45M structured for institutional and family-office capital.",
    cta: "Investor Access",
    to: "/investment",
    testid: "tricta-invest",
  },
  {
    code: "02",
    label: "Partner",
    title: "Strategic Partners",
    body: "Italian manufacturers, machinery suppliers, financiers, training institutions, export buyers.",
    cta: "Become a Partner",
    to: "/partner",
    testid: "tricta-partner",
    primary: true,
  },
  {
    code: "03",
    label: "Manufacture",
    title: "Manufacture in Botswana",
    body: "Secure production capacity inside the SEZA-aligned Lobatse facility. Reserved lines, audited quality.",
    cta: "Reserve Capacity",
    to: "/partner",
    testid: "tricta-manufacture",
  },
];

export default function TriCTA({ heading, kicker }) {
  return (
    <section data-testid="tri-cta-section" className="bg-[#1A1A1A] text-[#F9F9F6]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-14">
          <div className="col-span-12 md:col-span-8">
            <p className="eyebrow text-[#A8A8A0]">{kicker || "Three Tracks"}</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] mt-4">
              {heading || (
                <>
                  Invest. Partner.
                  <br />
                  <span className="italic text-[#E5C4A1]">Manufacture in Botswana.</span>
                </>
              )}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-l border-t border-[#333330]">
          {TRACKS.map((t) => (
            <Link
              key={t.code}
              to={t.to}
              data-testid={t.testid}
              className={`group border-r border-b border-[#333330] p-8 md:p-10 flex flex-col transition-colors duration-300 ${
                t.primary ? "bg-[#5C2018] hover:bg-[#1A1A1A]" : "bg-[#1A1A1A] hover:bg-[#0E0E0E]"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className={`font-serif text-xl tracking-tight ${t.primary ? "text-[#F9F9F6]" : "text-[#E5C4A1]"}`}>
                  {t.code}
                </span>
                <span className="text-[10px] uppercase tracking-[0.24em] text-[#A8A8A0] border border-[#333330] px-3 py-1">
                  {t.label}
                </span>
              </div>
              <h3 className="font-serif text-3xl md:text-[34px] tracking-tight leading-tight mt-12">
                {t.title}
              </h3>
              <p className={`mt-5 text-sm leading-relaxed ${t.primary ? "text-[#E0D8CD]" : "text-[#C7C7BF]"}`}>
                {t.body}
              </p>
              <div className="mt-auto pt-12 inline-flex items-center gap-3 text-[12px] uppercase tracking-[0.2em] font-semibold text-[#F9F9F6] group-hover:text-[#E5C4A1] transition-colors">
                {t.cta}
                <ArrowRight size={14} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
